/* unplugin-vue-components disabled */import script from "./RecipientSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecipientSelect.vue?vue&type=script&setup=true&lang=ts"

import "./RecipientSelect.vue?vue&type=style&index=0&id=525891c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525891c5"]])

export default __exports__